import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CLEAR_DATA_GUARD_FILTERS,
  GET_LOCATION_SUMMARY,
  GET_DATA_GUARD_FILTERS_LIST,
  SET_DATA_GUARD_SELECTED_LOCATION_FILTERS,
  SET_DATA_GUARD_SELECTED_POLICY_SUBTYPE_FILTERS,
  SET_DATA_GUARD_SELECTED_SEVERITY_FILTERS,
  SET_DATA_GUARD_SELECTED_USER_ROLES_FILTERS,
  SET_DATA_GUARD_SELECTED_OWNERS_FILTERS,
  SET_DATA_GUARD_SELECTED_USERS_FILTERS,
  SEARCH_DATA_GUARD_USERS,
} from "../Utility/DataguardConstant";
import ApplicationFilter from "../../SysGuard/Dashboard/Components/filters/ApplicationFilter";
import { fetchDetailPageData } from "./redux/detailPageActions";

export default function DataGuardFilter({
  popupClose,
  selectedCategory,
  config,
  fromTimeStamp,
  toTimeStamp,
  page,
  rowsPerPage,
  columnId = [],
}) {
  const dispatch = useDispatch();

  const {
    selectedLocationFiltersList = [],
    selectedPolicySubtypeFiltersList = [],
    selectedSeverityFiltersList = [],
    selectedUserRolesFiltersList = [],
    selectedOwnersFiltersList = [],
    selectedUsersFiltersList = [],
  } = useSelector((state) => state.DataguardReducer);

  const filterConfigMap = {
    location: {
      listSelector: (s) => s.DataguardReducer.locationFiltersList,
      selectedSelector: (s) => s.DataguardReducer.selectedLocationFiltersList,
      actionType: SET_DATA_GUARD_SELECTED_LOCATION_FILTERS,
      isCountry: true,
    },
    policyName: {
      listSelector: (s) => s.DataguardReducer.policySubtypeFiltersList,
      selectedSelector: (s) => s.DataguardReducer.selectedPolicySubtypeFiltersList,
      actionType: SET_DATA_GUARD_SELECTED_POLICY_SUBTYPE_FILTERS,
    },
    severity: {
      listSelector: (s) => s.DataguardReducer.severityFiltersList,
      selectedSelector: (s) => s.DataguardReducer.selectedSeverityFiltersList,
      actionType: SET_DATA_GUARD_SELECTED_SEVERITY_FILTERS,
      isRisk: true,
    },
    roleName: {
      listSelector: (s) => s.DataguardReducer.userRolesFiltersList,
      selectedSelector: (s) => s.DataguardReducer.selectedUserRolesFiltersList,
      actionType: SET_DATA_GUARD_SELECTED_USER_ROLES_FILTERS,
    },
    ownerName: {
      listSelector: (s) => s.DataguardReducer.ownersFiltersList,
      selectedSelector: (s) => s.DataguardReducer.selectedOwnersFiltersList,
      actionType: SET_DATA_GUARD_SELECTED_OWNERS_FILTERS,
    },
    name: {
      listSelector: (s) => s.DataguardReducer.usersFiltersList,
      selectedSelector: (s) => s.DataguardReducer.selectedUsersFiltersList,
      actionType: SET_DATA_GUARD_SELECTED_USERS_FILTERS,
      isSearchable: true, 
      onSearch: (queryString) => {
        dispatch({
          type: SEARCH_DATA_GUARD_USERS,
          payload: { queryString },
        });
      },
    },
  };

  const selectedFiltersMap = {
    location: selectedLocationFiltersList,
    policyName: selectedPolicySubtypeFiltersList,
    severity: selectedSeverityFiltersList,
    roleName: selectedUserRolesFiltersList,
    ownerName: selectedOwnersFiltersList,
    name: selectedUsersFiltersList,
  };

  const getTableParamDataDispatch = (selectedFilters) => {
    const finalFilters = Object.keys(selectedFiltersMap).reduce((acc, key) => {
      acc[key] = columnId.includes(key) ? selectedFilters : selectedFiltersMap[key];
      return acc;
    }, {});

    dispatch(
      fetchDetailPageData(selectedCategory, config.apiEndpoint, {
        fromTimeStamp,
        toTimeStamp,
        page,
        rowsPerPage,
        locationFilters: finalFilters.location,
        policySubtypeFilters: finalFilters.policyName,
        severityFilters: finalFilters.severity,
        userRolesFilters: finalFilters.roleName,
        ownersFilters: finalFilters.ownerName,
        userNamesFilters: finalFilters.name,
        columnId,
        filterType: selectedCategory,
      })
    );
  };

  const getTableDataDispatch = () => {
    if (!config) return;
    dispatch(
      fetchDetailPageData(selectedCategory, config.apiEndpoint, {
        fromTimeStamp,
        toTimeStamp,
        page,
        rowsPerPage,
      })
    );
    dispatch({ type: GET_LOCATION_SUMMARY, payload: { fromTimeStamp, toTimeStamp } });
    dispatch({
      type: GET_DATA_GUARD_FILTERS_LIST,
      payload: { filterEndpoint: config.FiltersListEndPoint, filterType: selectedCategory },
    });
  };

  const handleApply = (selectedFilters) => {
    popupClose();
    getTableParamDataDispatch(selectedFilters);
  };

  const handleClear = () => {
    popupClose();
    dispatch({ type: CLEAR_DATA_GUARD_FILTERS });
    getTableDataDispatch();
  };

  const validFilters = ["location", "policyName", "severity", "roleName", "ownerName", "name"];
  const activeFilters = columnId.filter((id) => validFilters.includes(id));

  return (
    <div>
      {activeFilters.length > 0 ? (
        activeFilters.map((id) => (
          <ApplicationFilter
            key={id}
            onApply={handleApply}
            onCancel={popupClose}
            onClear={handleClear}
            filterField={id}
            customFilterConfigMap={filterConfigMap}
            loc="dataGuard"
          />
        ))
      ) : (
        <div>No filter for now</div>
      )}
    </div>
  );
}